document.addEventListener('DOMContentLoaded', function() {  
  setDownloadLink("");
  $("#tool").change(function(){     
      toggleData();      
  });  
});

function toggleData(){
  var sku = $("#tool").val();
  switch(sku){
    case "400":
       setDownloadLink("https://cdn.shopify.com/s/files/1/0719/2163/1533/files/BLCKTEC_400_USER_GUIDE.pdf?v=1679973231");
      break;
    case "420":
      setDownloadLink("https://cdn.shopify.com/s/files/1/0719/2163/1533/files/BLCKTEC_420_USER_GUIDE.pdf?v=1679973323");
      break;
    case "410":     
    case "430":
      setDownloadLink("https://cdn.shopify.com/s/files/1/0719/2163/1533/files/BLCKTEC-QSG-DONGLE.pdf?v=1681441427");
      break;
    case "440":
      setDownloadLink("https://cdn.shopify.com/s/files/1/0663/8954/1107/files/BLCKTEC_440_USER_GUIDE.pdf?v=1689230734");
      break;
    default:
      setDownloadLink("");
      break;
  }
}

function setDownloadLink(url){
  if(url != ""){
    validateForm();
    $("#toolLink").attr("href", url);
    $("#toolLink").removeAttr("onclick");
    $("#toolLink").attr("target", "_blank");
  }else{
    $("#toolLink").attr("href","javascript:;");
    $("#toolLink").attr("onclick","return validateForm();");    
    $("#toolLink").removeAttr("target");
  }
}

function validateForm(){
   return checkRequiredFields('downloadContent');
}